import { privateDecrypt } from "crypto";

export default {
    center: {
        recommendTitle1: '您好，欢迎查阅',
        recommendTitle2: '文档',
        recommendTitle: '智能总结',
        helpTitle: '关于这篇文档，我还可以帮你做：',
        recommendedQuestions: '推荐问题',
        recommend: '您好，欢迎来到',
        loadingTitle: '正在阅读文档...',
        regenerate: '重新生成',
        assistantPlaceholder: '输入"/"唤醒指令助手，输入"{\'@\'}"对指定文件提问',
        reference: '内容为AI生成仅供参考',
        knowledgeHeader: '强悍的知识库 AI 助手',
        knowledgeHeaderTip: '基于大模型与文件对话，重塑文件查阅方式 ；洞悉海量纷繁知识文档，轻轻松松阅读理解',
        knowledgeTitle1: '文档精准解析',
        knowledgeTitle1Tip1: '精准识别文档段落：处理复杂排版、内容跨页等情况，确保原始数据精确性',
        knowledgeTitle1Tip2: '精准识别复杂表格：对合并单元格、复杂表格等情况精准识别，确保传递准确信息',
        knowledgeTitle2: '多维度提问',
        knowledgeTitle2Tip1: '推荐提问：基于文档内容引导提问，基于答案拓展问题',
        knowledgeTitle2Tip2: '全库提问：信息整理，全局语义检索，整库内容总结',
        knowledgeTitle3: '可信，可溯源',
        knowledgeTitle3Tip1: '有据可依：答案依据来源，展示引用页码或互联网链接地址',
        knowledgeTitle3Tip2: '一键溯源：点击溯源至原文且段落高亮',
        knowledgeDescLeft: '说明：支持解析 pdf、doc、docx、txt、md 格式的文件，字数限制',
        knowledgeDescRight: '百万字，升级扩容 敬请期待',
        createKnowledge: '创建知识库',
        editKnowledge: '编辑知识库',
        clickUpload: '点击上传',
        supportMore: '支持上传一个或多个文件',
        onlySupport: '仅支持上传word/pdf/txt/ppt文件，',
        limit: '限制',
        chatLog: '对话记录',
        stop: '停止生成',
        reopen: '即将为你打开全新对话，一起探索新话题',
        hello: '您好，我是雅意·YaYi',
        answer: '你可以对我说：',
        change: '换一批',
        promptCheck: 'Prompt查看',
        addConversation: '新建对话',
        copy: '复制',
        copySuccess: '复制成功',
        startConnection: '建立连接中',
        endConnection: '关闭连接中',
        startRecord: '开始录音',
        recording: '录音中',
        textPlaceHolder: '有什么问题尽管问我',
        allowFileType: '只允许上传文件的格式：',
        fileSizeMoreThan10: '文件大小超出10M',
        selectedContent: '已选中内容：',
        unfold: '展开',
        doWhat: '要对这句话做点什么呢？',
        welcome: '欢迎来到雅意YAYI平台',
        alreadyCharge: '系统已为您的账户充值',
        
        welcomeNew: '欢迎来到',
        welcomeTitle: '雅意畅语',
        welcomeTitle2: '智能对话平台',
        newUserTip: '新用户系统特别赠送',
        giveCount: '300',
        TipCount: '万 tokens',
        alreadyChargeTip: '即刻开启你的AI创新体验之旅～',

        yuan: '元！',
        fee: '费用说明',
        tips: '提示',
        token: '1 token 约等于 1.35 字符',
        feeLess: '若费用不足，您可以进入',
        chargeManagement: '充值管理',
        goCharge: '去充值费用。',
        gotIt: '我知道了',
        knowledgeName: '知识库名称',
        description: '简介',
        icon: '图标',
        knowledgePlaceholder: '请输入知识库名称',
        knowledgeCountLimit: '知识库名称不能超过20个字符',
        createSuccess: '创建成功',
        editSuccess: '编辑成功',
        minimize: '最小化',
        closeTask: '关闭任务',
        total: '共',
        totalFile: '个文件',
        succeeded: '已成功',
        fileCount: '个',
        failed: '失败',
        taskRunning: '任务运行中',
        allTaskSuccess: '全部任务成功',
        portionTaskFail: '部分任务失败',
        allTaskFail: '全部任务失败',
        uploadStatus0: '解析中',
        uploadStatus1: '解析中',
        uploadStatus2: '上传成功',
        uploadStatus3: '解析失败',
        uploadStatus4: '上传中',
        uploadStatus5: '上传失败',
        uploadStatus6: '容量不足',
        uploadStatus7: '解析为空',

        // new-start
        knowledgeTitle4: "多文档格式",
        knowledgeList: "知识库列表",
        placeholderSelect: '请选择',
        placeholderKeyword: '请输入知识库名称或标签',
        public: "公开",
        publicPrivate: "对内公开",
        private: "个人",
        update: "更新",
        name: '名称',
        type: "类型",
        fileNumber: "文件数",
        fileSize: "文件大小",
        updateTime: "更新时间",
        words: "字",
        all: "全部",
        // new-end
    },
    aside: {
        fileCount: '个文件',
        dirCount: '个文件夹',
        myKnowledge: '我的知识库',
        keyword: '关键词',
        separateKeyword: '多个关键词用空格隔开',
        noData: '暂无数据',
        createImmediate: '立即创建',
        word: '字',
        upgrade: '升级扩容',
        deleteFileConfirm: '您确认要删除该文档吗？一旦删除不可恢复',
        deleteFileAllConfirm: '您确认要删除该目录及其下的所有文档吗？一旦删除不可恢复',
        deleteAllFileConfirm: '您确认要删除根目录及其子目录下的所有文档吗？一旦删除不可恢复',
        addDirectory: '新增目录',
        uploadFile: '上传文件',
        edit: '编辑',
        delete: '删除',
        rename: '重命名',
        moveTo: '移动至',
        moveHere: '移动到这里',
        moveSuccess: '移动成功',
        deleteKnowledgeConfirm: '您确定要删除当前知识库吗？',
        cancel: '取消',
        confirm: '确定',
        deleteKnowledgeLeft: '删除知识库后，知识库内的所有文件将立即被永久删除，此操作不可撤销，请输入',
        deleteKnowledgeRight: '用以确认。',
        confirmNamePlaceholder: '请输入知识库名称以确认',
        deleteSuccess: '删除成功',
        inconsistentKnowledge: '知识库名称不一致',
        uploadImmediate: '立即上传',
        limitless: '不限制',
        knowledgeCapacity: '知识库容量',
        totalCapacity: '当前知识库总容量',
        remainCapacity: '剩余可用',
        deleteDirConfirm: '确认删除此文件夹吗？删除后无法恢复',
        deleteFileConfirm2: '确认删除此文件吗？',
        deleteDirTip: '删除文件夹后，文件夹内所有文件将被同步删除，此操作不可撤销。',
        deleteFileTip: '删除后无法恢复',
        newFolder: '新建文件夹',
        onlyAllow: '只允许导入',
        fileType: '格式的文件',
        fileSize200M: '文件大小超出200M',
        maxFolder: '最多只能创建7层目录',
        noResult: '搜索无结果',
        changeKey: '换个关键词试试',
        descUpdateTime: '按更新时间倒序',
        ascUpdateTime: '按更新时间正序',
        descFileSize: '按文件大小倒序',
        ascFileSize: '按文件大小正序',
        nameSort: '按名称排序',
        typeSort: '按类型排序',
        addURL: '添加URL',
        save: '保存',

        // new-start
        publicKnowledge:"公开知识库",
        // new-end
    },
    bottom: {
        serviceAgreement: '服务协议',
        privacyPolicy: '隐私政策'
    }
}